/**
 * Default theme configuration.
 * This file can be updated by exporting from the Theme Panel.
 *
 * To update: Open Theme Panel > Configure > Click "Export Config" > Paste here
 */

import type { ThemeConfig } from '@/contexts/ThemeContext';

export const DEFAULT_THEME: ThemeConfig = {
  mode: 'system',
  baseColor: 'slate',
  themeColor: 'blue',
  radius: 'default',
  style: 'vega',
  font: 'inter',
  preset: 'default',
};
